/**
 * In-memory holder for the candidate sign-session JWT.
 *
 * The token must NOT be persisted to localStorage / sessionStorage / cookies:
 * the redis-backed sign link is single-use and the JWT it issues is short-lived
 * (≈30 min). Keeping it in module memory means it dies with the tab — exactly
 * the lifetime we want and immune to XSS-driven persistent theft.
 */

let sessionToken: string | null = null;
let sessionExpiresAt: number | null = null;

const listeners = new Set<() => void>();

export const signLinkSession = {
  set(token: string, expiresAtIso?: string) {
    sessionToken = token;
    sessionExpiresAt = expiresAtIso ? new Date(expiresAtIso).getTime() : null;
    listeners.forEach((l) => l());
  },
  get(): string | null {
    if (sessionExpiresAt && Date.now() > sessionExpiresAt) {
      sessionToken = null;
      sessionExpiresAt = null;
    }
    return sessionToken;
  },
  clear() {
    sessionToken = null;
    sessionExpiresAt = null;
    listeners.forEach((l) => l());
  },
  subscribe(fn: () => void): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};
